const allowedUserTypes = ["contractor"];

export default allowedUserTypes;